import toast from "@/lib/toast";
import { format } from "date-fns";

export function dateFormatter(value: string | Date | null | undefined, formatStr: string): string {
  if (!value) return '';
  const date = new Date(value);
  if (isNaN(date.getTime())) return String(value);

  try {
    return format(date, formatStr);
  } catch (error : any) {
    toast.error(error);
    return String(value);
  }
}